import { CardContent } from "./internal/CardContent.js";
import { ElevatedCard } from "@myphx-engineering/phx-design-system";
import { jsx } from "react/jsx-runtime";

//#region src/components/pharmacy-card/PharmacyCard.tsx
/**
* Displays the information of a pharmacy option within a list of pharmacies that the user can choose to send their prescription
*/
const PharmacyCard = ({ title, description, pricing, value, subtitle, footer, toggleFavorite, additionalInfo, onClick, role, favorite = false }) => {
	return /* @__PURE__ */ jsx(ElevatedCard, {
		onClick,
		role,
		children: /* @__PURE__ */ jsx(CardContent, {
			title,
			description,
			pricing,
			additionalInfo,
			value,
			subtitle,
			toggleFavorite,
			footer,
			favorite
		})
	});
};

//#endregion
export { PharmacyCard };